var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"update-for-existing-enquiry"}},[_c('p',[_vm._v("Ok, thanks. If you would like to add additional information below for the advisor who picks it up to investigate.")]),_vm._v(" "),_c('textarea',{attrs:{"name":"comment","id":"comment"}}),_vm._v(" "),_c('SubmitButton',{attrs:{"btnText":"Submit Enquiry"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bfe4d98","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdateExistingEnquiryForm.vue
// module id = 110
// module chunks = 0